<template>
  <div class="main_b">
    <div class="top-section">
      <el-row type="flex" class="row-bg">
        <el-col :span="12">
          <div class="section-header">
            <p class="section-title">Validación de datos (Email y correo)</p>
          </div>
        </el-col>


        <el-col :span="11">
          <div>
            <el-input placeholder="Buscar por Alias/Email Cliente o CVE Promotor" v-model="searchText" class="input-with-select" clearable minlength="2">

              <el-button  slot="append" icon="el-icon-search" @click="validate" type="primary" circle></el-button>
            </el-input>
          </div>

        </el-col>


      </el-row>
    </div>
      <!-- Clients List -->
      <el-row type="flex">
        <el-col :span="24">
          <el-table  ref="singleTable"
                     v-loading="loading"
                     empty-text="Sin resultados"
                     :data="valid"
                    :row-class-name="tableRowClassName"
                     height="70vh"
                     @filter-change="filterChange"
          >
            <el-table-column prop="alias" label="Alias" width="80"></el-table-column>
            <el-table-column prop="nombre" label="Nombre" width="130"></el-table-column>
            <el-table-column prop="codigoCliente" label="Código" width="90" ></el-table-column>
            <el-table-column prop="mailSiap" label="Email" width="260">
              <template slot-scope="scope">
                <div slot="reference" class="name-wrapper">
                  <el-input  type="text" v-model.trim="scope.row.mailSiap" :disabled="scope.row.edited" clearable size="small"></el-input>
                  <!--<el-checkbox v-model="scope.row.checkMail" :disabled="scope.row.edited"></el-checkbox>-->
                </div>
              </template>
            </el-table-column>
            <el-table-column  prop="telCelular" label="Celular (10 dígitos)" width="160">
              <template slot-scope="scope">
                <el-input  type="text" v-model.trim="scope.row.telCelular" maxlength="10"
                           show-word-limit :disabled="scope.row.edited" clearable size="small" ></el-input>
                <!--<el-checkbox v-model="scope.row.checkTel" :disabled="scope.row.edited" ></el-checkbox>-->

              </template>
            </el-table-column>

            <el-table-column label="" width="160">
              <template slot-scope="scope">

                <el-button type="default"  size="mini" @click="handleSave(scope.$index, scope.row)" :disabled="scope.row.edited">Guardar</el-button>
                <el-button type="primary" icon="el-icon-edit" size="mini" @click="handleEdit(scope.$index, scope.row)" plain></el-button>
              </template>
            </el-table-column>
              <el-table-column label="" width="110">
                <template slot-scope="scope">
                  <el-button type="primary" size="mini" @click="handleValidation(scope.$index, scope.row)" :disabled="scope.row.validated" plain>Validar</el-button>
                  <!--<el-button v-if="scope.row.unico" type="warning" icon="el-icon-star-off" circle size="mini" @click="showunique"></el-button>-->
                </template>
            </el-table-column>
            <el-table-column v-if="email ==='middle@columbus.mx'" prop="cvePromotor" label="CVE" width="60"></el-table-column>

            <el-table-column prop="updatedAt" label="Última Actualización" width="100"></el-table-column>
            <el-table-column prop="strStatus" label="Envio" width="120"
                             :filters="[{ text: 'Enviado', value: 'Enviado' }, { text: 'Sin Enviar', value: 'Sin Enviar' }]"
                             :filter-method="filterTag"
                             filter-placement="bottom-end"></el-table-column>
          </el-table>
        </el-col>
      </el-row>


    <!-- FORM -->
    <el-dialog title="Validar Datos y enviar código al Cliente" :visible.sync="dialogFormVisible">

        <div v-if="formData.mailSiap">
          <el-form :model="formData">
            <el-form-item label="Email Cliente" :label-width="formLabelWidth">
              <el-input v-if="formData.mailSiap" v-model="formData.mailSiap"  maxlength="50" readonly style="width: 40%;" ></el-input>
              <el-input v-else-if="formData.mailSiap === ''" value="Sin datos de Correo"  maxlength="50" disabled style="width: 40%;" ></el-input>
            </el-form-item>
            <el-form-item label="Celular Cliente" :label-width="formLabelWidth">
              <el-input v-model="formData.telCelular"  readonly style="width: 40%;"></el-input>
            </el-form-item>
            <!--<p><b>Opcional</b></p>-->
            <!--<el-checkbox v-model="checked" > Enviar código al cliente por SMS</el-checkbox>-->
            <p>Enviar los datos del cliente al correo de contratos.</p>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">Cancelar</el-button>
            <el-button type="primary" @click="sendData(formData)">Enviar</el-button>
            </span>
          <p> {{formData.mailPromotor}}, actuando dentro del alias {{formData.alias}}. En mi carácter de Ejecutivo de Relación,
            manifiesto bajo protesta de decir verdad que la información presentada dentro del expediente que nos ocupa,
            misma que consiste en número de celular y correo electrónico, fue proporcionada por el cliente,
            la cual corroboré personalmente por lo que cualquier error u omisión en su veracidad, será mi única
            y absoluta responsabilidad. <b>Al enviar acepto las condiciones.</b></p>

        </div>
          <div v-else>
            <el-form :model="formData">
              <el-form-item label="Email Cliente" :label-width="formLabelWidth">
                <el-input v-if="formData.mailSiap" v-model="formData.mailSiap"  maxlength="30" readonly style="width: 40%;" ></el-input>
                <el-input v-else-if="formData.mailSiap === ''" value="Sin datos de Correo"  maxlength="50" disabled style="width: 40%;" ></el-input>
              </el-form-item>
              <el-form-item label="Celular Cliente" :label-width="formLabelWidth">
                <el-input value="Sin datos de Celular" disabled style="width: 40%;"></el-input>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">Cancelar</el-button>
                <el-button type="primary" @click="sendData" disabled>Enviar</el-button>
              </span>
          </div>
    </el-dialog>

  </div>
</template>

<script>
    import { updateValidation, getAllValidations, updateValidationStatus} from '@/graphql'

    export default {
        name: "Validacion",
        data () {
            return {

                loading: false,
                displaySendUrlDialog: false,
                inputVisible: false,
                inputValue: '',
                listTable : [],
                dialogFormVisible: false,
                formLabelWidth: '120px',
                formData : {},
                currentIndex : 0,
                filterStatus : '',
                checked : false,

                searchText: ''

            }
        },
        computed: {
            validateQuery: function () {
                return{
                    query: getAllValidations,
                    variables: {
                        email: this.email,
                        search: this.searchText
                    },
                    fetchPolicy: 'network-only',
                }
            },
            email: function () {
                return this.$store.getters.userInfo.email
            },
            valid: function(){
                //this.validate();
                return this.listTable
            }

        },
        mounted() {
            this.validate();
        },
        methods: {

            validate() {
                //console.log("Loading clients", this.listTable)
                this.loading = true;
                const q = this.validateQuery

                this.$apollo.query({
                    query: q.query,
                    variables: q.variables,
                    fetchPolicy: q.fetchPolicy
                })
                    .then((data) => {
                        //this.successHandler(data.data)
                        this.loading = false

                        /*
                        var datos = JSON.parse(data.data.validation.message)
                        console.log("1", datos[0])
                        var list = []
                        Object.keys(datos).forEach(function (key) {

                            //console.log(datos[key]['codigo_cliente'])

                            list.push(
                                {
                                    "alias": (datos[key]["alias"]),"nombreCliente": datos[key]["nombre_cliente"],
                                    "email":datos[key]["mail_cliente"], "codigo": datos[key]["codigo_cliente"],
                                    "celular": datos[key]["celular"], "enviado": datos[key]["validated"],
                                    "fecha_ultimo": datos[key]["fecha_ultimo"],"edited":true,
                                    "fecha_envio": datos [key]["fecha_envio"], "validate":false}
                                )
                        });
                        */
                        //this.listTable = []
                        this.listTable = data.data.allValidations
                        console.log('DATA', data.data.allValidations)

                    })
                    .catch((error) => { console.log(error) })
            },
            callFunction: function () {

                var currentDate = new Date();
                console.log(currentDate);

                var currentDateWithFormat = new Date().toJSON().slice(0,10).replace(/-/g,'/');

                console.log(currentDateWithFormat);
                return currentDateWithFormat

            },
            handleSave(index, row) {
                row.edited = true
                row.validated = false
                var pass = false
                // Check for blank values
                //if (row.checkTel === true && row.telCelular !== '' && row.checkMail === true && row.mailSiap !== ''  ){
                //    pass = true
                //}
                //if (row.checkTel === false && row.telCelular !== '' && row.checkMail === true && row.mailSiap !== ''  ){
                //    pass = true
                //}

                //console.log("Saved", index, row)
                this.update(index, row)
            },
            handleEdit(index, row) {
                row.edited = !row.edited
                row.validated = !row.validated
                //console.log('EDIT', index, row)
            },
            handleValidation(index, row){
                row.edited = true
                //console.log(index, row.mailSiap, row.telCelular)
                this.checked = false
                this.formData = row
                this.currentIndex = index
                this.dialogFormVisible = true
            },

            tableRowClassName({row, rowIndex}) {

                //console.log("COLOR", row.status, row.strStatus)
                if (row.status === true) {
                    //console.log('GREEN')
                    return 'success-row';
                }

                return '';
            },

            update(index, row){
                //console.log("CODIGO CLIENTE", row)

                this.$apollo.mutate({
                    mutation: updateValidation,
                    variables:  {
                        telCelular: row.telCelular,
                        mailSiap: row.mailSiap,
                        codigoCliente : row.codigoCliente,
                        checkMail : row.checkMail,
                        checkTel: row.checkTel
                },

                })
                    .then((data) => {
                        //this.successHandler(data.data)

                        //console.log('GUARDAR client', data.data.updateValidation.client)
                        //console.log('old ROW', row)
                        //this.listTable[index] = data.data.updateValidation.client
                        row.updatedAt = data.data.updateValidation.client.updatedAt
                        row.unico = data.data.updateValidation.client.unico
                        if (data.data.updateValidation.returnCode === 0){
                            this.$refs.singleTable.doLayout()
                            this.$message({
                                message: 'Datos Actualizados',
                                type: 'success'
                            })
                        }else{
                                this.$message.error('No se actualizaron los datos');
                            }

                    })
                    .catch((error) => {
                        console.log(error)
                        this.$message.error('Oops, this is a error message.');
                    })
            },
            showunique(){
                this.$message('Registro único');

            },

            sendData(){
                let checkCel = this.formData.telCelular;

                // Check if only digits otherwise can not send data
                if (checkCel === "" || /^\d+$/.test(checkCel)){

                    this.dialogFormVisible = false;

                    //console.log("DATOS!!!", this.formData, this.checked)

                    this.$apollo.mutate({
                        mutation: updateValidationStatus,
                        variables:  {
                            telCelular: this.formData.telCelular,
                            mailSiap: this.formData.mailSiap,
                            codigoCliente: this.formData.codigoCliente,
                            alias: this.formData.alias,
                            history: this.formData.history,
                            checked: this.checked,
                            mailPromotor: this.email
                        },
                    })
                        .then((data) => {
                            this.checked = false
                            //this.successHandler(data.data)
                            //this.formData.fecha_envio = "Enviado"
                            //console.log('Index', this.currentIndex)

                            //console.log('VALIDADO', data.data.updateValidationStatus.client)

                            //this.listTable[this.currentIndex] = data.data.updateValidationStatus.client
                            //this.listTable[this.currentIndex].status = true
                            //this.listTable[this.currentIndex].strStatus = "Enviado"

                            this.$message({
                                message: 'Correo Enviado',
                                type: 'success'
                            });
                            //console.log(this.listTable)
                            this.validate()
                            this.$refs.singleTable.doLayout()
                            // this.tableRowClassName(1)
                        })
                        .catch((error) => {
                            console.log(error)
                            this.$message.error('Error de conexión');
                        })

                }else {
                    this.$message.error('Datos incorrectos, Verificar formato');
                }

            },

            filterTag(value, row) {
                //console.log('Filter', value)
                //row.status = false;
                //this.$refs.singleTable.doLayout()

                if (row.strStatus === 'Sin Enviar'){
                    row.status = false

                }else if(row.strStatus === 'Enviado') {
                    row.status = true
                }
                return row.strStatus === value;
            },

            filterChange(filters) {
                //console.log('FILTER CHANGE', filters);
                //console.log('FILTER CHANGE', filters["el-table_2_column_15"][0]);

                this.validate()
                this.$refs.singleTable.doLayout()
            },
            /*
            changeBoxTel(row){
                if(row.checkTel){
                    console.log('true')
                }else {
                    console.log('valor falso')
                    row.telCelular = ''
                    }
            }*/
        },
    }
</script>

<style>
  .main_b {
    /* //display: block; */
    /* //width: 100%; */
    /* //box-sizing: border-box !important; */
    margin: 25px 0 38px 50px;
  }

  .section-header {
    display: flex;
    flex-direction: row;
    align-content: flex-start;
    padding-bottom: 10px;
  }

  .section-title {
    font-size: 18px;
    font-weight: 600;
    text-align: start;
    line-height: 16px;
  }

  p {
    font-size: 16px;
  }

  .el-table .warning-row {
    background: #fd7173;
  }

  .el-table .success-row {
       background: #f0f9eb;
     }

  .el-table-column .datetime{
    font-size: 10px;
    text-align: left;
  }

  .row-list{
    width:100%;
    height: 100%;
  }

</style>



// WEBPACK FOOTER //
// src/components/Validacion.vue